import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-arrow-left',
  standalone: true,
  imports: [],
  templateUrl: './icon-arrow-left.component.html',
  styleUrl: './icon-arrow-left.component.scss'
})
export class IconArrowLeftComponent {
  @Input() size: string = '1rem';
  @Input() color: string = 'currentColor';
}
